var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"reading-time"},[_vm._v(_vm._s(_vm.totalReadingTime)+" min read")])
}
var staticRenderFns = []

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./scripts/vue/ReadingTime.vue